import service from '../service/product_template'
import itemService from '../service/item'

export default {
  getGroupInfoForTemplate({ commit }, data) {
    return new Promise((resolve, reject) => service.getGroupInfoForTemplate(data).then((result) => {
      resolve(result)
      return result
    }, (e) => {
      reject(e)
    }))
  },
  getGroupProducts({ commit }, data) {
    return new Promise((resolve, reject) => service.getGroupProducts(data).then((result) => {
      resolve(result)
      return result
    }, (e) => {
      reject(e)
    }))
  },
  // 商品聚合页
  getSchemeListById({ commit }, data) {
    return new Promise((resolve, reject) => service.getSchemeListById(data)
    .then((result) => {
      resolve(result)
      return result
    },
    (e) => {
      reject(e)
    }))
  },
  getPreviewProductAttrsInfo({ commit }, productId) {
    return new Promise((resolve, reject) => itemService.getProductAttrsInfo(productId).then(
      (info) => {
        resolve(info);
      },
      (e) => {
        reject(e);
      },
    ));
  },
}
